<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <section class="content">
        <b-card class="mb-3" :header="heading" no-body>
          <div class="card-body">
            <div class="form">
              <div class="form-row">
                <div class="col-md-12">
                  <b-form-group label="For Project:">
                    <b-form-select :options="projectsList" v-model="itemForm.projectId" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Name:">
                    <b-form-input v-model="itemForm.name" maxlength="240" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Slug:">
                    <b-form-input v-model="itemForm.slug" placeholder="Leave empty to autogen" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Group:">
                    <b-form-select :options="knowGroupsToPick" v-model="itemForm.knowledgebaseGroupId" />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Content" :key="itemForm.content">
                    <markdwn-editor
                      ref="toastuiEditor"
                      id="toastuiEditor"
                      :initialValue="itemForm.content"
                      :options="editorOptions"
                      height="500px"
                      initialEditType="wysiwyg"
                      previewStyle="tab"
                    ></markdwn-editor>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </section>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <button
          class="btn btn-block btn-primary"
          type="submit"
          @click="SaveForm"
        >
          Save Changes
        </button>
        <router-link
          class="mt-2 btn btn-block btn-danger"
          :to="{ name: 'Admin.Knowledgebase.Pages.Index' }"
        >
          Cancel
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
let refOfHttp = null;
let refOfEditor = null;

let addImageBlobHook = function(blob, callback, source) {
  if(refOfEditor) {
    let fileName = blob.name;
    let reader = new FileReader();
    reader.onload =  function(_a) {
      let formData = new FormData();
      formData.append('formFile', blob);
      formData.append('extension', fileName.split('.').pop());
      let headers = { 'Content-Type': 'multipart/form-data' };
      refOfHttp.post('/api/common/tickets/imageUpload', formData, { headers }).then((resp) => {
        let getUrl = window.location;
        let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
        let oldContent = refOfEditor.editor.getMarkdown();
        refOfEditor.editor.setMarkdown(oldContent + "\r\n "+ " \r\n" + '!['+fileName+']('+resp.data.url+')'+ "\r\n  "+ "  \r\n  ")
      });
    };
    reader.readAsDataURL(blob);
  }
  callback();
  return false;
};
import { Editor } from '@toast-ui/vue-editor';
//const { chart, codeSyntaxHighlight, colorSyntax, tableMergedCell, uml } = Editor.plugin;
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Admin.Knowledgebase.Pages.Form',
  mixins: [crudMixinGen('docs/knowledgebasePages'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },
  components: {
    'markdwn-editor': Editor
  },

  data: () => ({
    heading: 'Knowledgebase Article Form',
    knowGroups: [],
    tempContent: '',
    knowGroupsToPick: [],
    editorOptions: {
      hooks: {
        addImageBlobHook: addImageBlobHook,
      },
      minHeight: '200px',
      language: 'en-US',
      useCommandShortcut: true,
      usageStatistics: true,
      hideModeSwitch: false,
      toolbarItems: [
        ['heading', 'bold', 'italic', 'strike'],
        ['hr', 'quote'],
        ['ul', 'ol', 'task', 'indent', 'outdent'],
        ['table', 'image', 'link'],
        ['code', 'codeblock'],
        ['scrollSync'],
      ],
      //plugins: [[chart, chartOptions], [codeSyntaxHighlight, { highlighter: Prism }], tableMergedCell, uml]
    }
  }),

  computed: {
  },

  watch: {
  },

  mounted() {
    this.loadGroups();
    this.ResetForm();
    if (this.id) {
      this.LoadItem(this.id).then((a) => {
        this.tempContent = this.itemForm.content;
        refOfEditor = this.$refs.toastuiEditor;
      })
    } else {
      this.readyToLoad = true;
        this.tempContent = this.itemForm.content;
        refOfEditor = this.$refs.toastuiEditor;
    }
    refOfHttp = this.$http;
  },

  methods: {
    getMarkdown() {
      let content = this.$refs.toastuiEditor.invoke('getMarkdown');
      return content;
    },
    loadGroups() {
      this.$http
        .post('/api/docs/knowledgebaseGroups/all')
        .then(resp => {
            this.knowGroupsToPick = [];
            this.knowGroups = resp.data;
            this.knowGroups.forEach((grop) => {
                this.knowGroupsToPick.push({value: grop.id, text: grop.name});
            })
        })
        .catch(err => {});
    },
    Slugify(str) {
      return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    },

    SaveForm() {
      this.itemForm.content = this.getMarkdown();
      this.itemForm.slug = this.Slugify(this.itemForm.name);
      this.SaveItem()
      .then(resp => {
        if (resp.status) {
          if (resp.id) {
            this.$swal({ title: 'Article Was Saved.', icon: 'info' });
          } else {
            this.$swal({ title: 'New Article was added.', icon: 'success' });
          }
          this.$router.push({
            name: 'Admin.Knowledgebase.Pages.Index'
          });
        } else {
          this.$swal({ title: resp.errorMessage, icon: 'error' });
        }
      })
      .catch(err => {
        console.error('saved po err', err);
      });
    }
  }
};
</script>
